import { ref } from 'vue';
import dayjs from 'dayjs';

import type { DateLib } from '@shared/lib';
import { ARRIVAL_FIELD, DEPARTURE_FIELD, type DateField } from '../config';

export const useDatepickerState = () => {
  const depDate = ref<DateLib.DateProp>('');
  const arrDate = ref<DateLib.DateProp>('');
  const selectedDateField = ref<DateField>(DEPARTURE_FIELD);

  const setDepDate = (date: DateLib.DateProp) => {
    if (dayjs(date).isAfter(arrDate.value)) {
      arrDate.value = '';
    }
    depDate.value = date;
  };

  const setArrDate = (date: DateLib.DateProp) => {
    if (dayjs(date).isBefore(depDate.value)) {
      depDate.value = date;
    }
    arrDate.value = date;
  };

  const handleDateChange = (dates: string[]) => {
    const date = dates[0];

    if (selectedDateField.value === DEPARTURE_FIELD) {
      setDepDate(date);
      selectedDateField.value = ARRIVAL_FIELD;
    } else {
      setArrDate(date);
      selectedDateField.value = DEPARTURE_FIELD;
    }
  };

  const handleRangeDateChange = (dates: DateLib.DateProp[]) => {
    const [depDate, arrDate = ''] = dates;

    if (depDate && !arrDate) {
      selectedDateField.value = ARRIVAL_FIELD;
    }

    if (depDate && arrDate) {
      selectedDateField.value = DEPARTURE_FIELD;
    }

    setDepDate(depDate);
    setArrDate(arrDate);
  };

  const clearDateField = (field: DateField) => {
    if (field === DEPARTURE_FIELD) {
      setDepDate('');
    } else {
      setArrDate('');
    }
  };

  const selectDateField = (field: DateField) => {
    selectedDateField.value = field;
  };

  return {
    depDate,
    arrDate,

    selectedDateField,
    handleRangeDateChange,
    handleDateChange,
    clearDateField,
    selectDateField,
    setDepDate,
    setArrDate,
  };
};
